// extracted by css-extract-rspack-plugin
export default {"wrapper":"R3_tEi"};